import { lazy, Suspense, useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import { GlobalStyle } from "./GlobalStyle";
import ReactModal from "react-modal";
import { Loader } from "./components/Loader/Loader";
import { Toaster } from "react-hot-toast";
import { toastOptions } from "./other/toastOptions";
import Layout from "./components/Layout/Layout";
import useLanguage from "./hooks/useLanguage.js";

ReactModal.setAppElement("#root");
const HomePage = lazy(() => import("./pages/home/index.jsx"));
const FeaturesPage = lazy(() => import("./pages/features/index.jsx"));
const SupportPage = lazy(() => import("./pages/support/index.jsx"));

const pages = [
  { path: "/", element: <HomePage /> },
  { path: "/features", element: <FeaturesPage /> },
  { path: "/support", element: <SupportPage /> },
];

function ScrollToHash() {
  const { hash } = useLocation();

  useEffect(() => {
    if (!hash) return;

    let attempts = 0;
    function scrollToElement() {
      const el = document.getElementById(hash.replace("#", ""));
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      } else if (attempts < 10) {
        attempts += 1;
        setTimeout(scrollToElement, 100); // пробуем снова через 100мс
      }
    }
    scrollToElement();
  }, [hash]);

  return null;
}

export const App = () => {
  const [language] = useLanguage();
  return (
    <div dir={language === "ar" ? "rtl" : "ltr"}>
      <GlobalStyle />
      <ScrollToHash />
      <Suspense fallback={<Loader className="apploader" />}>
        <Routes>
          <Route path={"/"} element={<Layout />}>
            {pages.map((page, index) => (
              <Route key={index} path={page.path} element={page.element} />
            ))}
          </Route>
          <Route path="*" element={<Layout />} />
        </Routes>
      </Suspense>
      <Toaster
        position="top-right"
        reverseOrder={false}
        toastOptions={toastOptions}
        containerStyle={{
          top: 60,
          right: 20,
        }}
      />
    </div>
  );
};
